import { render, staticRenderFns } from "./listOverdueDialog.vue?vue&type=template&id=9970db6e&"
import script from "./listOverdueDialog.vue?vue&type=script&lang=js&"
export * from "./listOverdueDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports